import React from "react";
// Adjust the path as necessary

export default function CardProductos({ title, img, description, icon }) {
  return (
    <div className="bg-sidom-orange rounded-xl w-full  h-[400px] sm:w-[320px] overflow-hidden shadow-lg hover:shadow-2xl ">
      <div className="relative ">
        <img src={img} alt={title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          <div className="absolute bottom-4 ">
            <div className="flex px-12  w-full  flex-col items-start justify-start ">
              <div className="w rounded-full flex items-center justify-center">
                {icon && <img src={icon} className="w-8 h-8 " alt={title} />}
              </div>
              <h1 className="text-xl font-bold text-white text-nowrap ">
                {title}
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className=" px-8 md:px-10 lg:px-11  mt-[40px]">
        <p className="text-sidom-light text-left  text-sm">{description}</p>
      </div>
    </div>
  );
}
